$(window).on('load',function(){

  $('.js-solution-slider').slick({
    slidesToShow: 3,
    centerMode: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.js-solution-slider2').slick({
    slidesToShow: 3,
    centerMode: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 2000,
    initialSlide: 2,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

});
